module.exports = __webpack_public_path__ + "media/placeholder_en.3df590e4.mp4";